<ng-container *ngIf="{ schoolPeriodSlots: schoolPeriodSlots$ | async } as vm">
  <ion-header>
    <ion-toolbar>
      <ion-title>Periodo</ion-title>
      <ion-buttons slot="start">
        <ion-back-button defaultHref="/tecservice-transportec/transportec" color="primary"></ion-back-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content class="ion-padding">
    <ion-list *ngIf="!vm.schoolPeriodSlots?.length && loading">
      <ion-item *ngFor="let stop of [0, 1, 2, 3, 4, 5]" lines="full">
        <ion-label>
          <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
          <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
        </ion-label>
      </ion-item>
    </ion-list>
    <ion-list>
      <ion-item *ngIf="!vm.schoolPeriodSlots?.length && !loading" lines="full">
        <ion-label>No hay periodos disponibles</ion-label>
      </ion-item>
      <ion-item *ngFor="let schoolPeriod of vm.schoolPeriodSlots" lines="full" (click)="goSubscribe(schoolPeriod)">
        <ion-label>
          {{ schoolPeriod.name }}
        </ion-label>
        <ion-button fill="clear" slot="end">
          <ion-icon name="arrow-forward"></ion-icon>
        </ion-button>
      </ion-item>
    </ion-list>
  </ion-content>
</ng-container>
